import React from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function BlogDetail() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [post, setPost] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    api
      .get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="flex justify-center py-40">
        <Loader2 className="animate-spin text-gray-400" />
      </div>
    );
  }
  if (error || !post) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-32 text-center" data-testid="blog-not-found">
        <h1 className="font-display lowercase font-bold text-4xl">
          post not found.
        </h1>
        <button onClick={() => nav("/blog")} className="kyv-btn-ghost mt-6">
          back to blog
        </button>
      </div>
    );
  }

  return (
    <article className="bg-section-glow py-16" data-testid="blog-detail-page">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <Link
          to="/blog"
          className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-blue-400 mb-8"
          data-testid="blog-back-link"
        >
          <ArrowLeft size={14} /> back to blog
        </Link>
        <div className="flex items-center gap-2 text-xs text-gray-400 mb-4">
          <span className="text-blue-400">{post.category?.toLowerCase()}</span>
          <span>·</span>
          <span>
            {new Date(post.created_at).toLocaleDateString("en", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
          </span>
        </div>
        <h1 className="font-display lowercase font-bold text-4xl sm:text-5xl tracking-tighter leading-tight" data-testid="blog-post-title">
          {post.title.toLowerCase()}
        </h1>
        {post.excerpt && (
          <p className="mt-5 text-lg text-gray-300 leading-relaxed">
            {post.excerpt}
          </p>
        )}
        {post.image_url && (
          <img
            src={post.image_url}
            alt={post.title}
            className="mt-8 w-full aspect-[16/9] object-cover rounded-2xl border border-white/10"
          />
        )}
        <div
          className="prose-kyvixe mt-10"
          dangerouslySetInnerHTML={{ __html: post.content }}
          data-testid="blog-post-content"
        />
      </div>
    </article>
  );
}
